'use client';

import { c as _c } from "react/compiler-runtime";
import { Transition, TransitionChild } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop';
import { cn } from '@src/utils/tailwind';
export const GeoRedirectionModalContent = t0 => {
  const $ = _c(17);
  const {
    children,
    onClose,
    isOpen,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TransitionChild><ModalBackdrop className="backdrop-blur-sm" /></TransitionChild>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("relative mx-auto overflow-hidden rounded-3xl bg-white shadow-md transition-all", "w-full p-6 pb-14 lg:max-w-[638px] lg:p-16", "data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-150 data-leave:ease-in data-closed:lg:translate-y-0 data-closed:lg:scale-95");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h2 className="text-heading-display-3">{title}</h2>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("flex items-center justify-center rounded-full p-1 transition-all hover:bg-gray-100");
    t5 = <XMarkIcon className="size-6 stroke-[2px]" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onClose) {
    t6 = <button onClick={onClose} className={t4}>{t5}</button>;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div className="mb-4 flex items-center justify-between gap-1 text-bodi-black-text lg:mb-1">{t3}{t6}</div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== children || $[12] !== t7) {
    t8 = <div className="fixed inset-0 flex items-center overflow-y-auto p-2"><TransitionChild><div className={t2}>{t7}{children}</div></TransitionChild></div>;
    $[11] = children;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isOpen || $[15] !== t8) {
    t9 = <Transition show={isOpen} as="div" className="relative z-1000">{t1}{t8}</Transition>;
    $[14] = isOpen;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};